/* eslint-disable react/require-default-props */

/* eslint-disable consistent-return */

/* eslint-disable jsx-a11y/media-has-caption */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useRef } from 'react';

import PlayPauseButton from '../buttons/PlayPause';
import VolumeButton from '../buttons/Volume';

import styles from '../../styles/partials/audio.module.css';

const propTypes = {
    audio: PropTypes.string,
    onMute: PropTypes.func,
    forcePlay: PropTypes.bool,
    loop: PropTypes.bool,
    controls: PropTypes.bool,
    className: PropTypes.string,
};

function AudioPlayer({
    audio: audioUrl = null,
    onMute = null,
    forcePlay = false,
    loop = false,
    controls = false,
    className,
}) {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [volume, setVolume] = useState(1);

    const togglePlayPause = useCallback(() => {
        setPlaying(!playing);
    }, [playing, setPlaying]);

    const cycleVolume = useCallback(() => {
        setVolume((prev) => {
            if (onMute !== null) {
                onMute(!(prev < 1));
            }
            if (prev === 0) {
                return 0.5;
            }
            if (prev === 0.5) {
                return 1;
            }
            return 0;
        });
    }, [setVolume, onMute]);

    useEffect(() => {
        if (audioRef.current === null) {
            return;
        }
        if (!playing) {
            audioRef.current.pause();
        } else if (playing) {
            try {
                audioRef.current.play();
            } catch (e) {
                // console.log('audioRef play error');
            }
        }
    }, [audioRef, playing]);

    useEffect(() => {
        if (audioRef.current === null) {
            return;
        }
        const interval = setInterval(() => {
            setProgress((audioRef.current.currentTime * 100) / audioRef.current.duration);
        }, 100);
        return () => {
            clearInterval(interval);
        };
    }, [audioRef, playing, setProgress]);

    useEffect(() => {
        if (audioRef.current === null) {
            return;
        }
        audioRef.current.volume = volume;
    }, [audioRef, volume]);

    useEffect(() => {
        if (forcePlay) {
            setPlaying(true);
        }
    }, [forcePlay]);

    return audioUrl !== null ? (
        <div className={classNames(styles.container, { [className]: className !== null })}>
            <div className={styles.inner}>
                <audio ref={audioRef} src={audioUrl} title={progress} loop={loop} />
                {controls ? (
                    <div className={styles.controls}>
                        <PlayPauseButton
                            onClick={togglePlayPause}
                            paused={!playing}
                            className={styles.button}
                        />
                        <VolumeButton
                            onClick={cycleVolume}
                            volume={volume}
                            className={styles.button}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    ) : null;
}

AudioPlayer.propTypes = propTypes;

export default AudioPlayer;
